<template lang="pug">
section.detail-section
  h3.section-title {{ title }}
  .section-content
    slot
</template>

<script>
export default {
  name: "DetailSection",
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
.detail-section{
  .section-title{
    font-weight: 700;
    font-size: 16px;
    color: #202948;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0;
  }
  .section-content{
    padding: 24px 0;
  }
}
</style>

